export default __webpack_public_path__ + "static/media/hl1.47b0383a.jpg";